import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { settingChangeToManager } from 'services/setting'

export default function useSetManager(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IChangeManagerSettingPayload) => {
            return settingChangeToManager(payload)
        },
        onSuccess: (data) => {
            refetch()
            toast.success('کاربر با موفقیت مدیر شد')
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutate }
}
